import Box from '@mui/material/Box';
import {useLogin} from '@refinedev/core';
import {FC, ReactElement, useEffect, useRef} from 'react';
import {useTranslation} from 'react-i18next';

import {FormHead} from '@minimal/auth/components/form-head';
import {AnimateLogoRotate} from '@minimal/components/animate';
import {AuthCenteredLayout} from '@minimal/layouts/auth-centered';

const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;

export const Login: FC = () => {
  const {mutate: login} = useLogin<CredentialResponse>();
  const {t} = useTranslation();

  const GoogleButton = (): ReactElement => {
    const divRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
      if (typeof window === 'undefined' || !window.google || !divRef.current) {
        return;
      }

      try {
        window.google.accounts.id.initialize({
          ux_mode: 'popup',
          client_id: GOOGLE_CLIENT_ID,
          auto_select: true,
          use_fedcm_for_prompt: true,
          callback: async (res: CredentialResponse) => {
            if (res.credential) {
              login(res);
            }
          },
        });
        window.google.accounts.id.renderButton(divRef.current, {
          theme: 'outline',
          size: 'medium',
          type: 'icon',
          shape: 'pill',
          text: 'continue_with',
        });
      } catch (error) {
        console.log(error);
      }
    }, []);

    return <div style={{display: 'inline-block'}} ref={divRef} id="login-with-google-button" />;
  };

  return (
    <AuthCenteredLayout>
      <AnimateLogoRotate sx={{mb: 3, mx: 'auto'}} />
      <FormHead title={t('pages.login.title')} />

      <Box textAlign="center">
        <GoogleButton />
      </Box>
    </AuthCenteredLayout>
  );
};
